// extracted by mini-css-extract-plugin
export default {"container":"Oo-z","ratingLayout":"Po-z","ratingLabel":"Qo-z","nonInteractiveRatingLabel":"Ro-z"};